import React, { useEffect, useState } from "react"
import Navbar from "../../components/navbar/Navbar"
import { graphql } from "gatsby"
import { getMenuConfigObject } from "../../utils/graphqlUtils"
import Swiper from "swiper"
import { ImageHeader } from "../../components/imageHeader"
import InfoIcon from "../../images/info_icon.png"
import BackArrow from "../../images/back_arrow.png"
import logo from "../../images/heidi-logo.png"
import { AppButton } from "../../components/button"
import { Divider } from "../../components/divider"
import { RichText } from "prismic-reactjs"
import * as languages from "../../../languages"
import { AppLink } from "../../components/appLink"
import "./index.scss"
import TemplateWrapper from "../../components/layout"

export const ProductDetails = ({ data, pageContext, ...props }) => {
  // console.log({ data })

  useEffect(() => {
    new Swiper(".swiper-container", {
      slidesPerView: 5,
      initialSlide: 0,
      spaceBetween: 10,
      // touchRatio: 0,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      scrollbar: {
        el: ".swiper-scrollbar",
        hide: false,
        dragSize: 30
      }
    })
  }, [])

  const [modalOpen, setModalOpen] = useState(false)

  const getRelatedProducts = () => {
    return ((data &&
      data.prismic &&
      data.prismic.allProduct_categorys &&
      data.prismic.allProduct_categorys.edges[0] &&
      data.prismic.allProduct_categorys.edges[0].node
    ))
  }

  const getProductData = () => {
    return (data &&
      data.prismic &&
      data.prismic.allProducts &&
      data.prismic.allProducts.edges[0] &&
      data.prismic.allProducts.edges[0].node)
  }

  const getLang = () => {
    if (pageContext.lang === languages.defaultLang) {
      return ""
    } else {
      return `/${pageContext.lang}`
    }
  }

  const excludeCurrentProduct = ({ product }) => {
    if (product && getProductData()) {
      if (product._meta && getProductData()._meta) {
        return product._meta.uid !== getProductData()._meta.uid
      } else {
        return true
      }
    } else {
      return true
    }
  }

  // console.log('prod data', getProductData())
  return (
    <TemplateWrapper>
      <section className="section">
        <Navbar {...props} menuObject={getMenuConfigObject(data)} data={data} pageContext={pageContext}/>
        <div className="product-details-container vh-100">
          <div className="navbar-placeholder"/>
          <div className="container middle-container">
            <div className="row w-100 py-3 position-relative">
              <AppLink className="back-button d-none d-sm-block" to={`/our-chocolate/#${getProductData()?.category?._meta.uid.toLowerCase()}#${getProductData()._meta.uid}`} pageContext={pageContext}>
                <div className="p-3 d-flex align-items-center"><img className="img-fluid" src={BackArrow}/><span
                  className="px-2">{getProductData()?.back_button_text ? getProductData()?.back_button_text : "back"}</span></div>
              </AppLink>
              <AppLink className="back-button d-block d-sm-none" to={`/our-chocolate/#_${getProductData()?.category?._meta.uid.toLowerCase()}#${getProductData()._meta.uid}`} pageContext={pageContext}>
                <div className="p-3 d-flex align-items-center"><img className="img-fluid" src={BackArrow}/><span
                  className="px-2">{getProductData()?.back_button_text ? getProductData()?.back_button_text : "back"}</span></div>
              </AppLink>
            </div>
            <div className="row w-sm-100 align-items-center middle-row">
              <div className="col-12 col-sm-6 mt-sm-3">
                <div className="d-block d-sm-none">
                  <ImageHeader noSpace imgSrc={getProductData()?.background_image?.url} resize/>
                  {getProductData() && !getProductData().no_aspect_ratio_image &&
                  <img className="img-fluid main-product-img" src={getProductData()?.product_image?.url} alt={getProductData()?.product_image?.alt}/>}
                  <img className="img-fluid main-product-img" src={getProductData()?.no_aspect_ratio_image?.url} alt={getProductData()?.no_aspect_ratio_image?.alt}/>
                </div>
                <div className="d-none d-sm-flex align-items-sm-center justify-content-sm-end pt-sm-5 w-100 text-right main-product-img-container"
                     style={{ backgroundImage: `url('${getProductData()?.background_image?.url}')` }}>
                  {getProductData() && !getProductData().no_aspect_ratio_image &&
                  <img className="img-fluid main-product-img" src={getProductData()?.product_image?.url} alt={getProductData()?.product_image?.alt}/>}
                  <img className="img-fluid main-product-img" src={getProductData()?.no_aspect_ratio_image?.url} alt={getProductData()?.no_aspect_ratio_image?.alt}/>
                </div>
              </div>
              <div className="col-12 col-sm-6 pt-sm-5 d-flex  justify-content-center align-items-sm-center position-relative clear-top-xs">
                <div className="text-center product-description-container position-relative">
                  {modalOpen &&
                  <div>
                    <div className="modal-overlay" onClick={() => setModalOpen(false)}/>
                    <div className="nutrition-info-modal text-left">
                      <div className="container p-0">
                        <div className="row m-0 d-block">
                          <div
                            className="semibold popup-title">{getProductData().nutrition_values_pop_up_title && getProductData().nutrition_values_pop_up_title[0] && RichText.render(getProductData().nutrition_values_pop_up_title)}</div>
                          <span className="modal-product-name">{getProductData()?.name}</span>
                          <div className="divider my-2"/>
                          {getProductData().nutrition_values && getProductData().nutrition_values[0] && RichText.render(getProductData().nutrition_values)}
                        </div>
                        <div className="divider my-2"/>
                        {getProductData().nutrition_values_pop_up_footer && getProductData().nutrition_values_pop_up_footer[0] && RichText.render(getProductData().nutrition_values_pop_up_footer)}
                        {getProductData().ingredients_list &&
                        <div>
                          <div className="divider my-2"/>
                          {getProductData().ingredients_list && getProductData().ingredients_list[0] && RichText.render(getProductData().ingredients_list)}
                        </div>
                        }
                      </div>
                    </div>
                  </div>
                  }
                  <img className="img-fluid d-none d-sm-inline-block" src={logo} width="75"/>
                  <img className="img-fluid nutritional-info-icon position-absolute d-block d-sm-none" src={InfoIcon} onClick={() => setModalOpen(true)}/>
                  <h1 className="text-uppercase product-range">
                    {getProductData() && getProductData().category && getProductData().category.name}
                  </h1>
                  <div className="product-name">{getProductData() && getProductData().name}</div>
                  <div className="product-description mt-3 mb-5">
                    {getProductData() && RichText.render(getProductData().description)}
                  </div>
                  {getProductData() && getProductData().buy_button && getProductData().buy_button[0] && !getProductData().buy_button[0].disabled && getProductData().buy_button[0].buy_button_link && getProductData().buy_button[0].buy_button_link.url &&
                  <AppButton
                    href={getProductData().buy_button[0].buy_button_link?.url} target={getProductData().buy_button[0].buy_button_link?._linkType}
                    pageContext={pageContext}
                    className="buy-button">{getProductData().buy_button[0].buy_button_text ? getProductData().buy_button[0].buy_button_text : "buy"}</AppButton>
                  }
                  <div className="d-block d-sm-none">
                    <Divider/>
                  </div>
                  <div className="other-range-products d-block d-sm-none">
                    <div className="text-uppercase text-center more-products-title">
                      {getProductData() && getProductData().related_products_title && RichText.render(getProductData().related_products_title)}
                    </div>
                    <div className="mobile-slider-container container-fluid">
                      <div className="swiper-container">
                        <div className="swiper-wrapper">
                          {
                            getRelatedProducts().products &&
                            getRelatedProducts().products.length &&
                            getRelatedProducts()
                              .products
                              .filter(excludeCurrentProduct)
                              .map(({ product }, index) =>
                                (<div className="swiper-slide" key={index.toString()}>
                                  <AppLink to={`/${getRelatedProducts()?._meta.uid}/${product?._meta.uid}`} pageContext={pageContext}>
                                    {product && !product.no_aspect_ratio_image &&
                                    <img className="img-fluid" src={product?.product_image?.url} alt={product?.product_image?.alt}/>}
                                    <img className="img-fluid" src={product?.no_aspect_ratio_image?.url} alt={product?.no_aspect_ratio_image?.alt}/>
                                  </AppLink>
                                </div>)
                              )
                          }
                        </div>
                        <div className="swiper-scrollbar"/>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="pl-sm-3 nutritional-info-icon-desktop position-absolute">
                  <img className="img-fluid d-none d-sm-block" src={InfoIcon} onClick={() => setModalOpen(true)}/>
                </div>
              </div>
            </div>
          </div>
          <div className="container pb-3 d-none d-sm-block other-range-products-desktop-container">
            <div className="other-range-products">
              {/*<div className="other-range-products-v2">*/}
              <Divider/>
              <div className="text-uppercase text-center more-products-title">
                {getProductData() && getProductData().related_products_title && RichText.render(getProductData().related_products_title)}
              </div>
              <div className="swiper-container overflow-hidden">
                <div className="swiper-wrapper">
                  {
                    getRelatedProducts().products &&
                    getRelatedProducts().products.length > 0 &&
                    getRelatedProducts().products
                      .filter(excludeCurrentProduct)
                      .map(({ product }, index) =>
                        (<div className="swiper-slide custom-slide" key={index.toString()}>
                          <AppLink to={`/${getRelatedProducts()?._meta.uid}/${product?._meta.uid}`} pageContext={pageContext}>
                            {product && !product.no_aspect_ratio_image &&
                            <img className="img-fluid" src={product?.product_image?.url} alt={product?.product_image?.alt}/>}
                            <img className="img-fluid" src={product?.no_aspect_ratio_image?.url} alt={product?.no_aspect_ratio_image?.alt}/>
                          </AppLink>
                        </div>)
                      )
                  }
                </div>
                <div className="swiper-button-prev filters-prev"/>
                <div className="swiper-button-next filters-next"/>
              </div>
            </div>
          </div>
        </div>
      </section>
    </TemplateWrapper>
  )
}

export default ProductDetails

export const pageQuery = graphql`
    query ProductDetailsQuery($lang: String, $uid: String, $category: String) {
        prismic {
            allProducts(lang: $lang, uid: $uid) {
                edges {
                    node {
                        _meta {
                            uid
                        }
                        category {
                            _linkType
                            ... on PRISMIC_Product_category {
                                name
                                filter_label
                                _meta {
                                    uid
                                }
                            }
                        }
                        details_button_text
                        back_button_text
                        related_products_title
                        name
                        description
                        nutrition_values_pop_up_title
                        nutrition_values
                        nutrition_values_pop_up_footer
                        ingredients_list
                        product_image
                        no_aspect_ratio_image
                        background_image
                        _linkType
                        buy_button {
                            disabled
                            buy_button_text
                            buy_button_link {
                                ... on PRISMIC__ExternalLink {
                                    url
                                    _linkType
                                }
                            }
                        }
                    }
                }
            }
            allProduct_categorys(lang: $lang, uid: $category) {
                edges {
                    node {
                        _meta {
                            uid
                        }
                        products {
                            product {
                                ... on PRISMIC_Product {
                                    _meta {
                                        uid
                                    }
                                    product_image
                                    no_aspect_ratio_image
                                }
                            }
                        }
                    }
                }
            }
            allMenus(lang: $lang) {
                edges {
                    node {
                        what_makes_heidi_unique_label
                        what_makes_heidi_unique_disabled
                        promo_campaign_label
                        promo_campaign_disabled
                        products_label
                        products_disabled
                        online_shop_label
                        online_shop_disabled
                        contact_disabled
                        chocolate_lover_disabled
                        contact_label
                        chocolate_lover_label
                        chocolate_label
                        chocolate_disabled
                        careers_label
                        careers_disabled
                        shops_page_label
                        shops_page_disabled
                    }
                }
            }
            allCookie_consents(lang: $lang) {
                edges {
                    node {
                        cookie_consent_text
                        cookie_consent_link {
                            ... on PRISMIC__ExternalLink {
                                url
                            }
                        }
                        cookie_consent_link_text
                        cookie_consent_button_text
                    }
                }
            }
        }
    }
`


